import { render, staticRenderFns } from "./ChangeArea.vue?vue&type=template&id=3a2a78e6&"
import script from "./ChangeArea.vue?vue&type=script&lang=js&"
export * from "./ChangeArea.vue?vue&type=script&lang=js&"
import style0 from "./ChangeArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports